module.exports = __webpack_public_path__ + "static/media/2.797fb250.jpg";